import { Box, BoxProps } from '@modusign/design-system';

import { useGNBFoldHandle } from '@app/containers/GlobalNavigationBar/GNBFoldHandleContext';
import useResponsiveValue from '@app/hooks/useResponsiveValue';

interface ModusignLogoProps extends BoxProps<'svg'> {}

function ModusignLogo(props: ModusignLogoProps) {
  const isMobileWidth = useResponsiveValue([true, true, false]);
  const { folded } = useGNBFoldHandle();

  if (isMobileWidth || !folded) {
    return <ModusignLogoFull {...props} />;
  }

  return <ModusignLogoInitial {...props} />;
}

function ModusignLogoInitial(props: ModusignLogoProps) {
  return (
    <Box height="42px" p="10px" width="56px">
      <Box
        as="svg"
        fill="none"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        height="23px"
        viewBox="0 0 222 209"
        width="24px"
      >
        <path
          clipRule="evenodd"
          d="M209.167 0L169.244 0.039343L92.5 200L132.423 199.962L209.167 0Z"
          fill="currentColor"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M184.167 101.771V208.333H221.667V4.16669L184.167 101.771Z"
          fill="currentColor"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M0.833313 0V204.167H40.9809V39.1524L92.8841 175.004L113.333 126.763L64.4504 0H0.833313Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </Box>
    </Box>
  );
}

export function ModusignLogoFull(props: ModusignLogoProps) {
  return (
    <Box
      as="svg"
      fill="none"
      height="100%"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 117 17"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M21.2243 8.51018C21.2304 11.6237 21.9874 14.8496 25.6736 14.842C29.5535 14.8339 30.1712 11.6045 30.1651 8.49156C30.1589 5.37744 29.5288 2.27146 25.746 2.2796C21.9627 2.28775 21.2181 5.39606 21.2243 8.51018ZM33.1251 8.48516C33.1358 13.88 30.8131 16.9895 25.7747 17C20.7362 17.0104 18.3911 13.9103 18.381 8.516C18.3703 3.2643 20.7026 0.0110827 25.7415 2.52947e-05C30.78 -0.0104502 33.115 3.23346 33.1251 8.48516ZM0.0309733 16.3583L0 0.578846L4.41025 0.569484L8.19285 11.564H8.23501L12.3489 0.552989L16.5152 0.543627L16.5457 16.3239L13.7771 16.3297L13.7517 3.57602H13.7104L9.26143 16.0039L7.17332 16.0074L2.82975 3.59876H2.78888L2.8134 16.3525L0.0309733 16.3583ZM45.1838 8.61192C45.1911 12.4395 44.283 14.1098 41.2061 14.1168L37.8378 14.122L37.8154 2.47562L40.9815 2.46864C43.9775 2.46282 45.1736 3.74024 45.1821 7.81346L45.1838 8.61192ZM41.3465 0.252497L34.8284 0.276358L34.8587 16.2817L41.3982 16.2881C46.4793 16.2776 48.1303 13.6722 48.1202 8.46818L48.1185 7.58067C48.1079 2.31442 46.185 0.242021 41.3465 0.252497ZM50.0586 10.4232L50.0395 0.544806L53.013 0.538987L53.0316 10.1694C53.0389 13.6648 54.7607 14.4853 57.0283 14.4813C59.2751 14.4766 60.8324 13.649 60.8256 10.1531L60.8071 0.52211L63.6992 0.516872L63.7166 9.40357C63.7262 14.3567 62.0493 16.8039 56.9014 16.8138C52.6733 16.8225 50.067 14.5162 50.0586 10.4232ZM66.0671 13.9484L66.0716 16.2611L71.1707 16.2501C75.2601 16.2629 77.4008 14.6077 77.3946 11.6315C77.389 8.85961 75.6083 7.83476 73.2182 7.2202L71.173 6.68769C69.6129 6.21572 68.9239 5.78331 68.921 4.48261C68.9182 3.11963 70.1728 2.69305 71.853 2.68955L75.6161 2.69188C76.3344 2.69014 76.951 2.16869 77.0858 1.44938L77.2941 0.23131L71.7879 0.252843C68.1231 0.281942 65.7448 1.82591 65.7504 4.53149C65.756 7.29876 67.694 8.4918 69.9628 9.04526L72.049 9.57776C73.7298 9.98747 74.2425 10.7749 74.2442 11.7619C74.247 12.9887 73.2311 13.9332 70.9236 13.9385L66.0671 13.9484ZM95.5586 2.67058C91.8135 2.67872 90.6437 4.95248 90.6499 7.98804L90.6516 8.83481C90.6578 12.1596 91.5726 14.2844 95.2576 14.2768C96.1679 14.2745 97.4028 14.1278 97.9896 13.941L97.9812 9.83173L95.5777 9.83638C95.1273 9.83696 94.7623 9.46625 94.7612 9.00707L94.7589 7.70113L100.79 7.68833L100.805 15.5665C99.5918 16.0856 97.4477 16.5442 95.2817 16.5488C90.646 16.5581 87.5758 14.4788 87.5657 8.86216L87.564 8.222C87.5517 2.08861 91.2216 0.304866 95.3514 0.296136L100.19 0.285661L99.8507 1.62419C99.6951 2.23584 99.1549 2.66301 98.5366 2.66418L95.5586 2.67058ZM103.205 0.359076L103.236 16.1042L106.149 16.0979L106.126 4.97187L113.053 16.0837L116 16.0774L115.969 0.332328L113.087 0.338569L113.044 11.2172L106.118 0.353727L103.205 0.359076Z"
        fill="#384251"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M84.6509 0.0418859L87.6643 0.0356445L80.9694 16.3255L77.9551 16.3318L84.6509 0.0418859Z"
        fill="#FDB700"
        fillRule="evenodd"
      />
    </Box>
  );
}
export default ModusignLogo;
